import * as React from 'react';
import InputWithIcon from "../../../hiberUiKit/src/atoms/Input/InputWithIcon";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import "./listFilter.scss";

interface Props {
	/**
	 * On filter change callback.
	 * @param {string} value
	 */
	onFilterChange: (value: string) => void;
	/**
	 * Filter value.
	 */
	filterValue: string;
	/**
	 * Indicates if lead list is loading.
	 */
	isLoading: boolean
	placeholder?: string
}

export default class ListFilter extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onReset = this.onReset.bind(this);
	}

	render() {
		return (
			<div className={"c-list-filter"}>
				<InputWithIcon type={"text"}
							   value={this.props.filterValue}
							   placeholder={this.props.placeholder || "Search"}
							   clearable={true}
							   onClearClick={this.onReset}
							   prependIcon={Icon.Search}
							   disabled={this.props.isLoading}
							   onChange={this.onChange}/>
			</div>
		);
	}

	/**
	 * On input change.
	 */
	onChange(evt: React.ChangeEvent<HTMLInputElement>) {
		this.props.onFilterChange(evt.target.value)
	}

	/**
	 * On reset button.
	 */
	onReset() {
		if (!this.props.isLoading)
			this.props.onFilterChange("")
	}
}
